import { MealSlot } from '@/plugins/api'

/**
 * Store Bữa ăn. Lọc theo type (fixed | supplementary).
 * BE đã sắp xếp sẵn theo nghiệp vụ nên FE giữ nguyên thứ tự trả về.
 */
export default {
  namespaced: true,
  state: {
    slots: [],
    totalItems: 0,
    loading: false,
    slot: {}
  },
  actions: {
    async fetchList({ commit }, query = {}) {
      commit('changeState', { loading: true })
      const [slots, totalItems] = await Promise.all([MealSlot.fetch({ ...query, _limit: -1 }), MealSlot.count(query)])
      commit('changeState', { slots, totalItems, loading: false })
    },
    async fetchOne({ commit }, id) {
      const slot = await MealSlot.fetchOne(id)
      commit('changeState', { slot })
      return slot
    },

    async create(_, data) {
      return MealSlot.create(data)
    },
    async update(_, { id, ...data }) {
      return MealSlot.update(id, data)
    },
    async remove(_, id) {
      return MealSlot.remove(id)
    }
  },
  mutations: {
    changeState(state, obj) {
      Object.assign(state, obj)
    }
  }
}
